import React, {useEffect, useRef, useState} from 'react';
import {useNavigate, useParams} from "react-router-dom";
import {useEntityObject} from "../../../dynamic365";
import {Note} from "../../../dynamic365/entities/Note";
import {Incident} from "../../../dynamic365/entities/Incident";
import {fileThumbnail, imageToBase64, ticketSeverity} from "../../../utils/functions";
import {Avatar} from "primereact/avatar";
import {Divider} from "primereact/divider";
import AnnotationItem from "./annontation-item";
import {InputText} from "primereact/inputtext";
import {ProgressSpinner} from "primereact/progressspinner";
import {useUser} from "../../../auth/UserContext";

function Index(props) {
    const params = useParams();

    const incident = useEntityObject(Incident());
    const note = useEntityObject(Note());
    const [ticket, setTicket] = useState();
    const [notes, setNotes] = useState();
    const [noteText, setNoteText] = useState();
    const [documentBody, setDocumentBody] = useState();
    const [filename, setFileName] = useState();
    const [loading, setLoading] = useState();
    const hiddenFileInput = useRef();
    const navigate = useNavigate();
    const user = useUser();

    const create_note=()=>{
        setLoading(true);
        note.create({
            body:{notetext: noteText, documentbody:documentBody, filename, isdocument:documentBody!==undefined},
            bind:["objectid", Incident() , params.id],
            onResult:()=>{
                setLoading(false);
                fetchIncident();
                setNoteText("");
                setFileName(undefined);
                setDocumentBody(undefined);
                setFileName(undefined);
            }
        })
    }

    const fetchIncident = ()=>{
        setNotes(undefined);
        incident.fetch({
            onResult:(result)=>{
                setTicket(result.data.value[0]);
                // console.log(result.data.value[0])
                note.fetch({
                    filters:{objectid:params.id},
                    orderBy:[{attributeName: note.entity.fields.createdon, descending:true}],
                    onResult:(result)=>{
                        // console.log(result.data.value);
                        setNotes(result.data.value);
                    }
                })
            },
            filters:{incidentid:params.id},
        })
    }

    useEffect(()=>{
        // console.log(user.state.userData)
        fetchIncident()
    },[])

    const disableNoteInput=()=>{
        if (ticket){
            if (user.state.userData.account){
                if (user.state.userData.account.AccountId===ticket._customerid_value) {
                    return ticket.statecode !== 0;
                }
                else return true
            }
            else return false;
        }
        return true;
    }

    return (
        <div className="flex flex-column h-full">
            <div className="flex justify-content-between align-items-center border-bottom-1 border-gray-300 w-full pr-3" >
                <div className="flex gap-3 align-items-center p-1">
                    <i className="pi pi-chevron-right p-2 cursor-pointer" onClick={()=>{navigate('/case')}}/>
                    <div className="flex flex-column text-sm justify-content-center">
                        <span className="font-bold flex gap-2 align-items-center">{ticket && ticket.title}<i className="pi pi-refresh text-xs cursor-pointer" onClick={()=>{fetchIncident()}}/></span>
                        <span className="text-gray-500">{ticket && ticket.description}</span>
                    </div>
                </div>

                <div className={`${ticket && ticketSeverity(ticket.statecode)} h-full text-sm p-4 pr-7`}>
                    {ticket && ticket["statecode@OData.Community.Display.V1.FormattedValue"]}
                </div>
            </div>
            <div className="flex-grow-1 h-1rem overflow-y-auto">
                <div className="w-full h-full flex justify-content-center overflow-y-auto">
                    <div className="w-full lg:w-8 flex flex-column p-2">
                        <div className="flex align-items-center gap-2">
                            {/*<Avatar size="large" icon="pi pi-user"/>*/}
                            {/*<span className="text-sm">{ticket && ticket["_customerid_value@OData.Community.Display.V1.FormattedValue"]}</span>*/}
                            {/*<Divider layout="vertical"/>*/}
                            <span className="text-gray-500 text-sm">شماره تیکت: <span className="english-font text-gray-900">{ticket && ticket.ticketnumber}</span></span>
                        </div>
                        {
                            notes ? notes.map(n=>(<AnnotationItem key={n.annotationid} note={n} incident={ticket}/>)):(<ProgressSpinner/>)
                        }
                    </div>
                </div>
            </div>
            <div>
                {
                    !disableNoteInput() && (
                        <div className="bg-gray-200 border-round-xl m-2 border-1 border-gray-400 ">
                            <div className="flex align-items-center p-2 gap-2">
                                {
                                    !loading ? (
                                        <Avatar className={`bg-primary-500 text-white ${!noteText && !documentBody && "hidden"}`} disabled={!noteText && !documentBody} shape="circle" icon="pi pi-arrow-right" onClick={()=>{create_note()}}/>
                                    ):(
                                        <ProgressSpinner className="h-2rem w-2rem"/>
                                    )
                                }

                                <InputText className="flex-1 bg-transparent border-none shadow-none outline-none p-1" placeholder="متن پیام..." value={noteText} onChange={(e)=>{setNoteText(e.target.value)}}/>
                                <Avatar className="bg-transparent" icon="pi pi-paperclip" onClick={()=>{hiddenFileInput.current.click();}}/>
                                <input ref={hiddenFileInput} className="p-hidden" type="file" onChange={(e)=>{const file = e.target.files[0]; setFileName(e.target.files[0].name) ;imageToBase64(file, (b64)=>{setDocumentBody(b64)});}}/>
                                {/*<Button label="ارسال" disabled={!noteText && !documentBody} loading={loading} onClick={()=>{create_note()}}/>*/}
                            </div>


                            {
                                documentBody && (<div className="flex align-items-center pl-2 gap-2 english-font ltr pb-1">
                                    <div>
                                        {fileThumbnail(filename, documentBody)}
                                    </div>
                                    <span>{filename}</span>
                                </div>)
                            }
                        </div>
                    )
                }
            </div>
        </div>
    );
}

export default Index;